import React, { useEffect, useState } from 'react'
import { Button, Table, Modal, Header, Checkbox, Grid } from 'semantic-ui-react'
import useAxios from '../../../lib/auth/useAxios'
import { formatTotalPrice, formatQuantities } from '../../../lib/utils/utils'
import AutoField from '../../../components/AutoField/AutoField'
import OrderItemDetailTwo from '../../../components/OrderItemDetail/OrderItemDetailTwo'

const AdminOrderRFQsRow = (props) => {
  const axios = useAxios()
  const [modalOpen, setModalOpen] = useState(false)
  const [rfqItems, setRfqItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const rfq = props.rfq

  const handleModalOpen = () => {
    setModalOpen(true)
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    let tempItemsHeaderRow = []
    const supplierNames = new Set()

    props.rfqs.forEach((rfq) => {
      rfq.rfq_items.forEach((rfqItem) => {
        if (rfqItem?.rfq?.supplier?.business?.name) {
          supplierNames.add(rfqItem?.rfq?.supplier?.business?.name)
        }
      })
    })

    const sortedSupplierNames = Array.from(supplierNames).sort()
    tempItemsHeaderRow.push(...sortedSupplierNames)

    setSuppliers(tempItemsHeaderRow)
    return () => {}
  }, [props.rfqs])

  function onCheckboxUpdate(data, supplierResponse) {
    const orderItemId = supplierResponse?.rfq_item?.order_item?.id

    if (data.checked) {
      // Remove any existing selection for this RFQ/row
      const filteredSelections = props.selected.filter(
        (item) => item?.rfq_item?.order_item?.id !== orderItemId
      )
      // Add the new selection
      setSelectedSupplier(supplierResponse?.rfq?.supplier?.business?.name)
      props.setSelected([...filteredSelections, supplierResponse])
    } else {
      // When unchecking, only remove this specific selection
      setSelectedSupplier(null)
      props.setSelected(
        props.selected.filter(
          (item) => item?.rfq_item?.order_item?.id !== orderItemId
        )
      )
    }
  }

  function getSupplierResponse(supplierName) {
    let supplierResponse
    rfq?.rfq_items?.forEach((rfqItem) => {
      if (rfqItem?.rfq?.supplier?.business?.name === supplierName) {
        supplierResponse = rfqItem
      }
    })
    return (
      <>
        <Grid>
          <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              label={''}
              name="checkboxRadioGroup"
              checked={selectedSupplier === supplierName}
              onChange={(e, data) => onCheckboxUpdate(data, supplierResponse)}
            />
          </Grid.Column>
          <Grid.Column>
            <p>
              {formatTotalPrice(supplierResponse?.rfq_item?.supplier_price)}
              {'/'}
              {supplierResponse?.rfq_item?.supplier_uom?.short_name}
            </p>
            <p style={{ whiteSpace: 'nowrap' }}>
              {formatQuantities(supplierResponse?.rfq_item?.supplier_quantity)}{' '}
              {supplierResponse?.rfq_item?.supplier_uom?.short_name}
            </p>
          </Grid.Column>
        </Grid>
      </>
    )
  }

  function getBuyerPrice() {
    // Get buyer price from any of the rfq_items (they should all have the same buyer info)
    const rfqItem = rfq?.rfq_items?.[0]?.rfq_item
    if (rfqItem?.buyer_price && rfqItem?.buyer_submitted) {
      return (
        <div>
          <p>
            {formatTotalPrice(rfqItem?.buyer_price)}
            {'/'}
            {rfqItem?.buyer_uom?.short_name || rfqItem?.supplier_uom?.short_name}
          </p>
          <p style={{ whiteSpace: 'nowrap' }}>
            {formatQuantities(rfqItem?.buyer_quantity)}{' '}
            {rfqItem?.buyer_uom?.short_name || rfqItem?.supplier_uom?.short_name}
          </p>
        </div>
      )
    }
    return <span style={{ color: '#888' }}>Not submitted</span>
  }

  return (
    <>
      <Table.Row selectable className={`rfq-row`}>
        <Table.Cell>
          <OrderItemDetailTwo orderItem={rfq?.order_item} />
        </Table.Cell>
        <Table.Cell>
          {rfq?.order_item?.quantity} {rfq?.rfq_item?.supplier_uom?.short_name}
        </Table.Cell>
        <Table.Cell>
          {getBuyerPrice()}
        </Table.Cell>
        {suppliers?.map((supplier) => {
          return (
            <Table.Cell key={supplier}>
              {getSupplierResponse(supplier)}
            </Table.Cell>
          )
        })}
      </Table.Row>

      <Modal open={modalOpen} onClose={handleModalClose} size="large">
        <Modal.Header>RFQ Details</Modal.Header>
        <Modal.Content>
          <Header as="h3">RFQ #{rfq?.rfq_number}</Header>
          <Header as="h4">Supplier: {rfq?.supplier?.business?.name}</Header>

          {loading ? (
            <div>Loading RFQ items...</div>
          ) : (
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Product</Table.HeaderCell>
                  <Table.HeaderCell>Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Unit of Measure</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {rfqItems.map((item) => (
                  <Table.Row key={item.id}>
                    <Table.Cell>
                      {item.order_item?.product_variant?.product_name}
                    </Table.Cell>
                    <Table.Cell>{item.supplier_quantity}</Table.Cell>
                    <Table.Cell>{item.supplier_price}</Table.Cell>
                    <Table.Cell>{item.supplier_uom?.name}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleModalClose}>Close</Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

export default AdminOrderRFQsRow
